export const config = {
    siteId: process.env.REACT_APP_SITE_ID,
    adsignId: process.env.REACT_APP_ADSIGN_ID,
    channelId: process.env.REACT_APP_CHANNEL_ID,
    screenId: process.env.REACT_APP_SCREEN_ID,
    xApiToken: process.env.REACT_APP_API_KEY,

    platformType: process.env.REACT_APP_PLATFORM_TYPE,
    api: process.env.REACT_APP_API,
    assetUrl: process.env.REACT_APP_ASSET_URL,
    baseUrl: process.env.REACT_APP_BASE_URL,
    s3: process.env.REACT_APP_S3,
    s3Url: process.env.REACT_APP_ASSET_URL,
    adsignSiteId: process.env.REACT_APP_ADSIGN_SITE_ID,
    mediaIds: {
        screensaverId: process.env.REACT_APP_SCREENSAVER_ID,
        eventsId: process.env.REACT_APP_EVENTS_ID,
        promotionsId: process.env.REACT_APP_PROMOTIONS_ID,
        artMurals: process.env.REACT_APP_ART_MURALS,
    },
    tenantIds: {
        amenitiesId: process.env.REACT_APP_AMENITIES_ID,
    },
    visualIds: {
        logoId: process.env.REACT_APP_LOGO_ID,
        backgroundAppId: process.env.REACT_APP_BACKGROUND_APP_ID,
        placeholderId: process.env.REACT_APP_PLACEHOLDER_ID,
    },
    listMenuId: process.env.REACT_APP_LIST_MENU_ID,
    listAmenitiesId: process.env.REACT_APP_LIST_AMENITIES_ID,
    buildingInfoId: process.env.REACT_APP_BUILDING_INFO_ID,
    env: process.env.REACT_APP_ENV,
};

export const mapOption = {
    hideUserLocation: true,
    highlightColor: '#EE2E2E',
    isShowAllFloor: false,
    floorLabel: {
        color: 'white',
        size: 0,
    },
    isDisplayMinimap: false,
    minZoom: 500,
    maxZoom: 300,
    disableZoom: false,
    disablePanning: false,
    disableRotation: false,
    arrowSize: 1,
    arrowYLevel: 0,
    additionalCameraHeight: 600,
    additionalYLevel: 16,
    autoFocusToDirection: true,
    showIconOnTooltip: true,
    hideCheckpointTooltip: true,
    loadingComponent: <div />,
};

export const PAGES = {
    HOMEPAGE: 'homepage',
    EVENTS: 'events',
    PROMOTIONS: 'promotions',
    DIRECTORY: 'directory',
    FLOORGUIDE: 'floorguide',
    MURALS: 'murals',
    INFORMATION: 'information',
};

export const DIRECTORY_SELECTOR = {
    CATEGORY: 'category',
    LEVEL: 'level',
};
